import { render, staticRenderFns } from "./wxblank.vue?vue&type=template&id=fe27d2d2"
import script from "./wxblank.vue?vue&type=script&lang=js"
export * from "./wxblank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports